import { useMemo } from 'react';
import useFetchBusinessUnits from './useFetchBusinessUnits';
import { getBUFromLocalStorage } from '../utils';
export default function useCurrentBusinessUnit() {
  const buValue = getBUFromLocalStorage();
  const {
    data
  } = useFetchBusinessUnits();
  return useMemo(() => {
    if (buValue === 'ALL') {
      return undefined;
    }
    const currentBuId = parseInt(buValue, 10);
    return data.find(bu => bu.id === currentBuId);
  }, [buValue, data]);
}